import { ButtonText } from "@ui"
import { mergeClasses } from "@lib/css"

import { SmartBannerCloseIcon } from "../atoms"

import type { ButtonProps } from "@ui"

export function SmartBannerCloseButton(props: Omit<ButtonProps, "children">) {
  const { className, ...rest } = props
  const classes = `h-6 w-6`

  return (
    <ButtonText {...rest} className={mergeClasses(classes, className)}>
      <SmartBannerCloseIcon />
    </ButtonText>
  )
}
